import { render, staticRenderFns } from "./WmFaq.vue?vue&type=template&id=710d62ce&scoped=true"
import script from "./WmFaq.vue?vue&type=script&lang=js"
export * from "./WmFaq.vue?vue&type=script&lang=js"
import style0 from "./WmFaq.vue?vue&type=style&index=0&id=710d62ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d62ce",
  null
  
)

export default component.exports